import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/services/login/login.service';
import { SweetServices } from 'src/services/sweet.services';
import { AppComponent } from '../../app.component';
import { ActivatedRoute } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-reset-pass-form',
  templateUrl: './reset-pass-form.component.html',
  styleUrls: ['./reset-pass-form.component.css'],
})

export class ResetPassFormComponent implements OnInit {
  selectedLanguage = environment.lang;
  public lang: string = environment.lang;
  public traduccion = environment.traduccion;
  userToken: any;
  passwordErrors: string[] = [];
  hasUpperCase = false;
  hasLowerCase = false;
  hasNumber = false;
  hasSpecialChar = false;
  isValid: boolean = false;
  version = environment.version;
  mostrarPassword: boolean = false;
  loadingService = inject(LoadingService);

  constructor(
    private alerta: SweetServices,
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.userToken = params.get('token');
    });
    this.validatePassword(' ');
    this.isValid = false;
  }

  resetpassForm = {
    Login: '',
    Password: '',
    Bloqueo: false,
    version: environment.version,
  };

  submitResetPassword(evt: Event) {
    evt.preventDefault()
    this.loadingService.mostrar();
    this.resetpassForm.Login = this.userToken;
    if (this.resetpassForm.Password === '') {
      this.loadingService.ocultar();
      this.alerta.AlertaErrorTimer('Llena el Formulario');
    } else {
      this.loginService.restablecerPassword(this.resetpassForm).subscribe(response => {
        if (response === null) {
          this.loadingService.ocultar();
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        } else if (response.isCorrect === 'false') {
          this.loadingService.ocultar();
          this.alerta.AlertaError(response.message);
        } else {
          this.correctResetpass();
        }
      }, (err) => {
        this.loadingService.ocultar();
        this.alerta.AlertaCatch(err);
      }
      );
    }

  }

  private correctResetpass() {
    this.loadingService.ocultar();
    this.alerta.AlertaSuccessTimer("Se restableció su contraseña correctamente.");
    this.goLogin();
  }

  goLogin() { 
    this.router.navigate(['/', 'login']); 
  }

  public cancelar() {
    this.goLogin();
  }

  validatePassword(inputControl: any) {
    const password = this.resetpassForm.Password || '';

    this.hasUpperCase = /[A-Z]/.test(password);
    this.hasLowerCase = /[a-z]/.test(password);
    this.hasNumber = /\d/.test(password);
    this.hasSpecialChar = /[@$!%*?&]/.test(password);

    this.passwordErrors = [];
    this.isValid = true;
    if (inputControl.errors) {
      if (inputControl.errors['required']) {
        this.passwordErrors.push('La contraseña es obligatoria.');
        this.isValid = false;
      }
      if (inputControl.errors['minlength']) {
        this.passwordErrors.push('La contraseña debe tener al menos 12 caracteres.');
        this.isValid = false;
      }
      if (inputControl.errors['pattern'] && !this.hasUpperCase) {
        this.passwordErrors.push(
          'La contraseña debe contener al menos una letra mayúscula.'
        );
        this.isValid = false;
      }
      if (inputControl.errors['pattern'] && !this.hasLowerCase) {
        this.passwordErrors.push(
          'La contraseña debe contener al menos una letra minúscula.'
        );
        this.isValid = false;
      }
      if (inputControl.errors['pattern'] && !this.hasNumber) {
        this.passwordErrors.push(
          'La contraseña debe contener al menos un número.'
        );
        this.isValid = false;
      }
      if (inputControl.errors['pattern'] && !this.hasSpecialChar) {
        this.passwordErrors.push(
          'La contraseña debe contener al menos un caracter especial (e.g., @$!%*?&).'
        );
        this.isValid = false;
      }
    }
  }
  prevenirPegado(evt: Event) {
    if(environment.production){
      evt.preventDefault();
    }
  }
  togglePassword() {
    this.mostrarPassword = !this.mostrarPassword;
  }  
}
